<template>
    <div class="dashboard-container">
        <side-bar />
        <div class="main-content">
            <h2>{{ distributorName }} Distributor Dashboard</h2>
            <hr class="h2" />
            <h3>Welcome, {{ userName }}</h3>
            <div class="flex-container">
                <div class="left-section">
                    <div class="container">
                        <DistriDashTiles />
                    </div>
                    <div class="container">
                        <div class="container">
                            <h3>Partners</h3>
                            <PartnerTable />
                        </div>
                    </div>
                    <div class="container">
                        <!-- Customers and bots by partner -->
                    </div>

                    <div class="flex-container-1">
                        <div class="container half-width">

                        </div>
                        <div class="container half-width">

                        </div>
                    </div>
                </div>

                <div class="right-section">
                    <div class="container">
                        <DistiOpportunitiesChart />
                    </div>
                    <div class="container">

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DistriDashTiles from '../vuetify/DistriDashTiles.vue';
import SideBar from './SideBar.vue'
import PartnerTable from '../vuetify/PartnerTable.vue';
import DistiOpportunitiesChart from '../vuetify/DistiOpportunitiesChart.vue';
export default {
    name: 'DistributorDashboard',
    components: {
        SideBar,
        DistriDashTiles,
        DistiOpportunitiesChart,
        PartnerTable
    },
    data() {
        return {
            distributorGuid: '',
            distributorName: '',
            userName: '',
            userRole: '',
        };
    },

    mounted() {
        this.distributorGuid = localStorage.getItem('distributorGuid') || '';
        if (!this.distributorGuid) {
            this.$router.push('/home');
        }
        this.distributorName = localStorage.getItem('distributorName') || '';
        this.userName = localStorage.getItem('userName') || '';
        this.userRole = localStorage.getItem('userRole') || '';

        // Reset customer and bot details
        localStorage.removeItem('PartnerGUID');
        localStorage.removeItem('customerGUID');
        localStorage.removeItem('customerName');
        localStorage.removeItem('botName');
        localStorage.removeItem('botID');
        localStorage.removeItem('botType');
        localStorage.removeItem('botDID');
    },
}
</script>


<style scoped>
.dashboard-container {
    display: flex;
    height: 100vh;
}

.main-content {
    flex: 1;
    padding: 20px;
}

h1 {
    margin-top: 10px;
}

/* .container {
    display: flex;
    max-width: 980px;
    width: 100%;
    margin: 0 auto;
    padding: 20px;
}

.container-btn {
    display: flex;
    max-width: 980px;
    margin: 0 auto;
    padding: 20px;
    justify-content: flex-end;
}

.logout-button-container {
    display: flex;
}

.logout-button {
    background-color: #E6C7EB;
    color: black;
    padding: 10px 20px;
    text-decoration: none;
    border-radius: 50px;
    cursor: pointer;
    flex: 1;
}

.logout-button:hover {
    background-color: #FE602F;
} */
.flex-container,
.flex-container-1 {
    display: flex;
    flex-direction: row;
}


.container {
    max-width: 980px;
    margin: 20px;
    flex-grow: 1;
}

.tile {
    display: inline-block;
}


.right-section {
    max-width: 400px;
    width: 25%;
}

.container.half-width {
    width: 50%;
}
</style>